module.exports = __webpack_public_path__ + "d621f6ba18d7dfe56717c670e22a49a2.pdf";